export default {
  bind: function (el, bindings, vnode) {
  },
  inserted: function (el, bindings) {
    // console.log(el, bindings);
    const $target = typeof el.innerText === 'string' ? el : '';
    let result = '';

    for(let t of $target.innerText) {
      var prevText;

      if(t.match(/(。|、)/gi)) {

        result = result.slice(0, -1);
        result += prevText.replace(prevText, `<span class="yakumono--prev">${prevText}</span>`);
        result += t.replace(t, `<span class="yakumono">${t}</span>`);
      } else if(t.match(/(^|\r?\n)(\r?\n)/mg)) {

        result += '<br />';
      } else {

        result += t;
      }

      prevText = t;
    }

    $target.innerHTML = result;
  },
  update: function (el, bindings) {
  },
  componentUpdated: function(el, bindings) {
  },
  unbind: function (el) {

  }
}


// WEBPACK FOOTER //
// ./src/plugins/kerning/directive.js